import script from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageToolbar.vue?vue&type=style&index=0&id=1700e803&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1700e803"]])

export default __exports__